import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState,
         QuizPlayerStateMachineCommonEvents } from './quiz-player-state-machine-state'
import { QuizPlayerStateMachineData } from '../data';

const debug = Debug('quiz-player-error-state')

interface Events extends QuizPlayerStateMachineCommonEvents {
}

export class QuizPlayerErrorState extends QuizPlayerStateMachineAbstractState<Events> {

  public readonly name = 'error'

  constructor(private state: QuizPlayerStateMachineData,
              private error: unknown) {
    super()
  }

  enter() {
    debug('enter')
    this.state.goToError(this.error)

    // TODO: EMIT ERROR TO USER
    console.error(`Error occured in quiz player: `, this.error)
    setTimeout(() => {
      throw new Error(`Error occured in quiz player: ` + JSON.stringify(this.error))
    }, 0)
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }
}
